export default {
	label: 'Dashboard',
	approachingDueDate: 'Measures approaching due date',
	duedateMethods: 'Measures due date status',
	byModules: 'By modules',
	overallChart: 'Over all status',
	total: 'Total',
}
